import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var OptionsManager = /*#__PURE__*/function () {
  function OptionsManager() {
    _classCallCheck(this, OptionsManager);
  }
  _createClass(OptionsManager, null, [{
    key: "hasOption",
    value: function hasOption(value, option) {
      return value.some(function (valueOption) {
        return valueOption.id === option.id;
      });
    }
  }, {
    key: "findIndex",
    value: function findIndex(value, option) {
      return value.findIndex(function (valueOption) {
        return valueOption.id === option.id;
      });
    }
  }, {
    key: "add",
    value: function add(value, option) {
      value = Array.isArray(value) ? value : [];
      if (OptionsManager.hasOption(value, option)) {
        return value;
      }
      return [].concat(_toConsumableArray(value), [option]);
    }
  }, {
    key: "remove",
    value: function remove(value, option) {
      var _this = this;
      if (Array.isArray(option.id)) {
        var val = value;
        option.id.forEach(function (id) {
          val = _this.remove(val, _objectSpread(_objectSpread({}, option), {}, {
            id: id
          }));
        });
        return val;
      }
      if (!OptionsManager.hasOption(value, option)) {
        return value;
      }
      var optionIndex = OptionsManager.findIndex(value, option);
      return [].concat(_toConsumableArray(value === null || value === void 0 ? void 0 : value.slice(0, optionIndex)), _toConsumableArray(value === null || value === void 0 ? void 0 : value.slice(optionIndex + 1)));
    }
  }]);
  return OptionsManager;
}();

export { OptionsManager as default };
